<script>
export default {
  name: 'Card',
  props: {
    pageId: { type: Number, required: true },
    title: { type: String, required: true },
    image: { type: String, default: '' },
    description: { type: String, default: '' },
    postType: { type: String, default: '' },
    isGroup: { type: Boolean, default: false },
    pages: { type: Array, default: () => [] },
  },
  computed: {
    folderLabel() {
      return this.isGroup ? this.pages[0]?.label || null : null;
    },
    routeName() {
      return this.postType ? `${this.postType}_posts` : 'posts';
    },
    routeConfig() {
      const config = {
        name: this.routeName,
        params: { page_id: this.pageId },
      };
      if (this.isGroup && this.folderLabel) {
        config.query = { folder_label: this.folderLabel };
      }
      return config;
    },
    displayImage() {
      if (this.isGroup) return null;
      return this.image;
    },
    folderInitial() {
      if (this.isGroup) {
        return (this.folderLabel || this.title || '').charAt(0).toUpperCase();
      }
      return null;
    },
  },
  methods: {
    handleClick() {
      this.$router.push(this.routeConfig);
    },
  },
};
</script>

<template>
  <div
    class="max-w-sm bg-white rounded-xl shadow-lg dark:bg-n-solid-2 cursor-pointer transition-transform transform hover:scale-105 border border-[#eaeaea] dark:border-0"
    @click="handleClick"
  >
    <div
      v-if="isGroup"
      class="rounded-t-xl w-[24rem] aspect-square flex items-center justify-center bg-slate-100 dark:bg-slate-700"
    >
      <span class="text-8xl font-bold text-slate-900 dark:text-white uppercase">
        {{ folderInitial }}
      </span>
    </div>

    <img
      v-else-if="displayImage"
      class="rounded-t-xl w-[24rem] aspect-square object-cover"
      :src="displayImage"
      alt="Card image"
    />

    <div
      v-else
      class="rounded-t-xl w-[24rem] aspect-square flex items-center justify-center bg-slate-100 dark:bg-slate-700"
    >
      <span class="text-8xl font-bold text-slate-900 dark:text-white uppercase">
        {{ title.charAt(0) }}
      </span>
    </div>

    <div class="px-6 py-3">
      <h5
        class="mb-2 text-lg font-bold tracking-tight text-slate-900 dark:text-white"
      >
        {{ title }}
      </h5>
      <p v-if="description" class="text-sm text-slate-600 dark:text-slate-400">
        {{ description }}
      </p>
    </div>
  </div>
</template>
